import BaseModel from './base';
/**
  так. смотри как грузить файлы где нету directory_id

  POST 1/event-directory-document/1386/upload
  вот сюда

  {
    "document": {
      "name": "YIqLbgptLByLIfu56ombT1bA2e4UCQ8o.xlsx",
      "original_name": "original_name"
      // --- ИЛИ ---
      "id": 245,
    },
    "user_id": 9
  }
  user_id - это когда от тренера грузишь
 */
export default class EventDocument extends BaseModel {
  constructor(document, url) {
    super(document, url);

    this.assign = document.assign || []; // [{ event_id: 1377, nomination_id: 1958 }, ...]

    this.title = document.title || ''; // Используется, когда directory_id === null

    this.directory_id = document.directory_id || null;
    this.directory_name = document.directory_name || '';

    this.required = document.required;
    this.description = document.description;

    this.event_id = document.event_id;
    this.nomination_id = document.nomination_id;

    this.agreement = document.agreement || null; // { id, text }
    this.template = document.template || null; // { id, url }

    this.user_value = document.user_value || null; // Ответ пользователя *если через форму запрашивать
  }

  get displayTitle() {
    return this.directory_name || this.title || 'Документ';
  }

  totalAssign(eventId, nominationId) {
    return (!this.event_id || this.event_id === eventId)
      && (this.nomination_id === nominationId || !this.nomination_id);
  }

  currentAssign(eventId, nominationId) {
    return (this.assign || []).find(({ event_id, nomination_id }) =>
      eventId === event_id && nomination_id === (nominationId || null),
    );
  }

  isAssigned(eventId, nominationId) {
    return !!this.currentAssign(eventId, nominationId);
  }

  isGlobal(eventId) {
    return !!this.currentAssign(eventId, null);
  }

  assignRequired(eventId, nominationId) {
    return this.currentAssign(eventId, nominationId)?.options?.required ?? this.required;
  }
}
